// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.grid-wrapper[data-v-1292f7c6] {\n  -webkit-flex-grow: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n  min-height: 360px;\n}\n.pagination-wrapper[data-v-1292f7c6] {\n  margin-top: 8px;\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
